<template>
 <div class='cumulativeRevenueBox'>
    <!-- <van-nav-bar title="累计收益"  left-arrow right-text="筛选">
        <template #right>
            <van-icon name="search" size="18" text="筛选"/>
        </template>
    </van-nav-bar> -->
    <van-nav-bar
        title="累计收益"
        :right-text="rightText"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        :class="{ showSelectIcon: isShowSelectIcon }"
    />

    <div class="cumulativeRevenueListCont">
        <div v-if="listData.length">
            <div class="cumulativeRevenueList" v-for="(item,index) in listData" :key="index" @click="jumpCRListDetailHandle(item)">               
                <div class="cumulativeRevenueListLeft">
                    <span>{{item.months}}</span>
                </div>

                <div class="cumulativeRevenueListRight">
                    <span v-if="item.income > 0">+{{item.income}}</span>
                    <span v-else>{{item.income}}</span>
                    <span>{{item.orderNum}}笔订单</span>
                    <font class="rightArrorIcon"></font>

                </div>

            </div>
        </div>

        <div class="noTuiguangList" v-else>暂无数据</div>



        <!-- <div class="cumulativeRevenueList">
            
            <div class="cumulativeRevenueListLeft">
                <span>2021-05</span>
            </div>

            <div class="cumulativeRevenueListRight">
                <span>+100.00</span>
                <span>20笔订单</span>
                <font class="rightArrorIcon"></font>

            </div>

        </div>

        <div class="cumulativeRevenueList">
            
            <div class="cumulativeRevenueListLeft">
                <span>2021-05</span>
            </div>

            <div class="cumulativeRevenueListRight">
                <span>+100.00</span>
                <span>20笔订单</span>
                <font class="rightArrorIcon"></font>
            </div>
        </div> -->
    </div>


    <div class="selectResultCont" v-show="isShowDatapicker">
        <div class="coverLayer"></div>
        <div class="selectKuang">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                :min-date="minDate"
                :max-date="maxDate"
                :formatter="formatter"
                @confirm="confirmData"
                @cancel="cancelDatapicker"               
            />
        </div>
    </div>

     <Footer></Footer>

 </div>
</template>

<script>
import Vue from 'vue'
import $ from "jquery";
import { Toast } from 'vant';
import Footer from './footer';




export default {
    name: "cumulativeRevenueList",
    data () {
        return {
            title: '累计收益',
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 10, 1),
            currentDate: new Date(),
            isShowDatapicker: false,
            isShowSelectIcon: true,
            rightText: '筛选',

            paging: {
                params: {
                    pageNum: 1,
                    pageSize: 10
                },
            
                total: 0,
                totalPages: 0,
            },


            currentYear: '',
            currentMouth: '',
            currentYearMouth: null,


     
            loadMoreStatus: "more",
            total: 0,
            listData: []
           


        };
    },
    components: {
        Footer,
    },

    computed: {
    },


    created(){
        localStorage.setItem("currentPromationNav",'mine')   
    },

    mounted(){
        this.getData()

        
        $(window).scroll(() => {
            //判断是否滑动到页面底部
            if (
                Math.round($(window).scrollTop()) ===
                $(document).height() - $(window).height()
            ) {
                // TODO 滑动到底部时可请求下一页的数据并加载，加载可使用append方法
                this.reachBottom();
            }
        });
       
    },
    destroyed(){
        
    },

    methods: {

        onClickLeft() {
            this.$router.go(-1);
        },

        onClickRight() {
            if (this.isShowSelectIcon) {
                this.isShowDatapicker = true;                
            } else {
                this.isShowSelectIcon = true;
                this.currentYearMouth = null
                this.rightText = '筛选';
                this.getData()
            }
        },

        formatter(type, val) {
            if (type === 'year') {
                return `${val}`;
            } else if (type === 'month') {
                return `${val}`;
            }
            return val;
        },

        confirmData(val) {
            this.currentYearMouth = val.getFullYear() + '-' + (val.getMonth() + 1 < 10 ? '0' + (val.getMonth() + 1) : val.getMonth() + 1)
            console.log('this.currentYearMouth====', this.currentYearMouth)
            this.isShowDatapicker = false;
            this.rightText = '取消筛选';
            this.isShowSelectIcon = false;
            this.getData()
        },
        cancelDatapicker() {
            this.isShowDatapicker = false;
        },

        jumpCRListDetailHandle(item) {
            this.$router.push({
                path: '/cumulativeRevenueDetail',
                query:{
                    mouth: item.months,
                }                
            })             
        },


        getData(type) {
            this.$api.agentManage.findMonthIncomeList(
                {
                    pageNum: this.paging.params.pageNum,
                    pageSize:  this.paging.params.pageSize,
                    month: this.currentYearMouth                
                }

            )
            .then(res=>{
                    if (res.data) {
                        if (type === "reachBottom") {
                            this.listData = this.listData.concat(res.data.list);
                        } else {
                            this.listData = res.data.list || [];
                        }
                        this.total = res.data.total;
                        if (this.total <= this.paging.params.pageNum * this.paging.params.pageSize) {
                            this.loadMoreStatus =
                                type === "reachBottom" ? "noMore" : "none";
                        } else {
                            this.loadMoreStatus = "more";
                        }
                    }

            })

        },
        
        reachBottom() {
            if (this.total > this.paging.params.pageNum * this.paging.params.pageSize) {
                this.paging.params.pageNum = this.paging.params.pageNum + 1;
                this.loadMoreStatus = "loading";
                this.getData("reachBottom");
            } else {
                this.loadMoreStatus = "noMore";
            }
        },
       
   
   
   
   
   
   },



}

</script>


<style  scoped>
 @import "../asset/css/agentManage.css";
</style>